import type { ReactNode, HTMLAttributes, TdHTMLAttributes, CSSProperties } from 'react'
import { cn } from '@/lib/cn'

export function Table({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('overflow-x-auto rounded-lg border border-border bg-card', className)}>
      <table className="w-full border-collapse text-left">{children}</table>
    </div>
  )
}

export function THead({ children }: { children: ReactNode }) {
  return (
    <thead className="border-b border-border bg-accent/30">{children}</thead>
  )
}

export function TBody({ children }: { children: ReactNode }) {
  return <tbody className="divide-y divide-border">{children}</tbody>
}

export function Tr(props: HTMLAttributes<HTMLTableRowElement>) {
  return <tr {...props} className={cn('hover:bg-muted/50', props.className)} />
}

export function Th({ children, className, style }: { children?: ReactNode; className?: string; style?: CSSProperties }) {
  return (
    <th
      scope="col"
      className={cn(
        'table-cell table-header text-left whitespace-nowrap',
        className,
      )}
      style={style}
    >
      {children}
    </th>
  )
}

export function Td({ children, className, ...rest }: TdHTMLAttributes<HTMLTableCellElement>) {
  return <td {...rest} className={cn('table-cell text-foreground', className)}>{children}</td>
}
